
import axios from "axios"

export function getOrderRequestorDropdown (params) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/order/get-requestor-dropdown`, {params})
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};